import { render, staticRenderFns } from "./saveVideo.vue?vue&type=template&id=cfb36696&"
import script from "./saveVideo.vue?vue&type=script&lang=js&"
export * from "./saveVideo.vue?vue&type=script&lang=js&"
import style0 from "./saveVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports